import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle} from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Select,
  Button,
  Space,
  message,
  DatePicker
} from "antd";
import { HomeOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import dayjs from "dayjs";
import commonFn from "@/utils/commonFn";

const ViewLoanModal = forwardRef(({ submitInitFn }, ref) => {
    const [form] = Form.useForm();
    const [type, setType] = useState('add');
    const [id, setId] = useState(0);
    const [rollId, setRollId] = useState(0);
    const [modalName, setModalName] = useState('Payment Request');
    const [modalFlag, setModalFlag] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [detail, setDetail] = useState(null);
    
    useImperativeHandle(ref, () => ({
      openModal: ({type, modalName, rollId, id}) => {
        setType(type)
        setModalName(modalName)
        setId(id)
        setRollId(rollId)
        setModalFlag(true)
      }
    }));

    const afterOpenChangeFn = (flag) => {
      if(flag){
        if(type !== 'add'){
          getDetailFn()
        } else {
          getPropIdListFn()
        }
      }else{
        setDetail(null)
        setPropIdList([])
        setGlAcctList([])
        form.resetFields();
        setBtnLoading(false)
        setBtnDisabled(false)
      }
    }

    const [propIdList, setPropIdList] = useState([]);

    const getPropIdListFn = async (content = '') => {
      const response = await http.get(api.propSearch, { params: { content } });
      if (response.code === "1") {
        const list = (response.data || []).map((item) => ({
          ...item,
          value: item.propId,
          label: item.propName,
        }));
        setPropIdList(list);
      }
    };

    const onTypeChange = (value, option) => {
      if(value){
        glAcctFun(value)
        form.setFieldsValue({
          monthlyInterestGlAcct: '',
          monthlyPrincipalGlAcct: '',
          liabilityGlAcct: '',
          expenseGlAcct: '',
        })
      }
    };

    const [glacctList, setGlAcctList] = useState([]);
    
    const glAcctFun = async (propId) => {
      const response = await http.get(api.mortgageGlAcct,  { params: {propId } });
      if (response) {
        const formattedData = response.map((item) => ({
          value: item.glAcct,
          label: item.glAcctName,
          title: item.title,
        }));

        setGlAcctList(formattedData);
      }
    };

    const getDetailFn = async() => {
      setBtnDisabled(true)
      const response = await http.get(api.getRollingSubDetail, { params: {id} });
      if (response?.code === "1") {
        const { paidOffDate, soldDate, propList, propId } = response.data
        await glAcctFun(propId)
        const temp = {
          ...response.data,
          paidOffDate: paidOffDate && dayjs(paidOffDate),
          soldDate: soldDate && dayjs(soldDate),
        }
        setDetail(temp)
        const propListTemp = propList.map(item => ({ ...item, value: item.propId, label: item.propName }))
        setPropIdList(propListTemp);
        form.setFieldsValue(temp);
      }
      setBtnDisabled(false)
    }

    const testFn = async () => {
      console.log(rollId,'===rollId');
    }

    const submitAddOrEditFn = async(type) => {
      const flag = type === 'add'
      setBtnLoading(true)
      const { paidOffDate, soldDate } = form.getFieldValue()
      const response = await http.post(flag ? api.saveRollingSub : api.updateRollingSub, {
        ...form.getFieldValue(),
        rollId,
        paidOffDateStr: paidOffDate?.format('YYYY-MM-DD') || '',
        soldDateStr: soldDate?.format('YYYY-MM-DD') || '',
      });
      if (response.code === "1") {
        message.success(`${flag ? 'New' : 'Edit'} successfully`);
        setModalFlag(false)
        submitInitFn();
      } else {
        commonFn.modalFailedFn(response)
      }
      setBtnLoading(false)
    }

    const submitFn = async() => {
      form.validateFields().then(value => {
        if(type === 'add' || type === 'edit'){
          submitAddOrEditFn(type)
        }
      }).catch(err =>{
        console.log(err,'===err');
      })
    }

  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold", color: "#3c8dbc" }}>
          <HomeOutlined style={{ marginRight: "8px" }} />
          {modalName}
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      centered
      open={modalFlag}
      onCancel={() => setModalFlag(false)}
      footer={null}
      maskClosable={false}
      afterOpenChange={afterOpenChangeFn}
      width="30%"
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{span: 8}}
        wrapperCol={{span: 16}}
        labelWrap={true}
        labelAlign="right"
        validateMessages={{
          required: "${label} is required!",
        }}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              name="propId"
              label="Property"
              rules={[{ required: true, message: 'Property is required!' }]}
            >
              <Select
                showSearch
                placeholder="Select a type"
                onChange={onTypeChange}
                onSearch={getPropIdListFn}
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={propIdList}
              />
            </Form.Item>

            {/* {commonFn.formInputNumberDoc({
              form,
              name: "monthlyFee",
              label: "Monthly",
              allowNegative: true
            })} */}

            {commonFn.interestRateDoc({
              form,
              name: "loanRatio",
              label: "Ratio",
              allowNegative: false,
              validator: (_, value, callback) => {
                console.log(value, '===value');
                // if(!value && value != 0)return
                if(((value || value === 0) && value <= 0 || value > 100)){
                  callback('The Ratio Must Be Between 0 And 100.')
                } else {
                  callback()
                }
              }
            })}

            {/* {commonFn.formInputNumberDoc({
              form,
              name: "monthlyInterest",
              label: "Interest",
              allowNegative: true
            })} */}

            <Form.Item
              name="monthlyInterestGlAcct"
              label="Interest GL Account"
              rules={[{ required: true, message: 'Interest GL Account is required!' }]}
            >
              <Select
                showSearch
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={glacctList}
              />
            </Form.Item>

            {/* {commonFn.formInputNumberDoc({
              form,
              name: "monthlyPrincipal",
              label: "Principal",
              allowNegative: true
            })} */}

            <Form.Item
              name="monthlyPrincipalGlAcct"
              label="Principal GL Account"
              rules={[{ required: true, message: 'Principal GL Account is required!' }]}
            >
              <Select
                showSearch
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={glacctList}
              />
            </Form.Item>

            <Form.Item
              name="liabilityGlAcct"
              label="Liability GL"
            >
              <Select
                showSearch
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={glacctList}
              />
            </Form.Item>

            <Form.Item
              name="expenseGlAcct"
              label="Expense GL"
            >
              <Select
                showSearch
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={glacctList}
              />
            </Form.Item>

            {commonFn.formInputNumberDoc({
              form,
              name: "currentLoan",
              label: "Current Loan",
              allowNegative: true,
              isNoRequired: true,
            })}

            {commonFn.formInputNumberDoc({
              form,
              name: "originalLoan",
              label: "Original Loan",
              allowNegative: true
            })}

            {/* {commonFn.formInputNumberDoc({
              form,
              name: "allocation",
              label: "Allocation",
              allowNegative: true,
              isNoRequired: true,
            })} */}
 
            <Form.Item
              name="paidOffDate"
              label="Paid Off Date"
            >
              <DatePicker
                style={{ width: "100%" }}
                format="MM/DD/YYYY"
              />
            </Form.Item>

            <Form.Item
              name="soldDate"
              label="Sold Date"
            >
              <DatePicker
                style={{ width: "100%" }}
                format="MM/DD/YYYY"
              />
            </Form.Item>

          </Col>
        </Row>
      </Form>
      <div style={{textAlign:'center'}}>
        <Space align="center">
          {/* <Button key="back" onClick={testFn}>
            TEST
          </Button> */}
          <Button key="back" onClick={() => setModalFlag(false)}>
            Cancel
          </Button>
          {
            type !== 'view' && (
              <Button type="primary" onClick={() => submitFn()} loading={btnLoading} disabled={btnDisabled}>
                Submit
              </Button>
            ) || null
          }
        </Space>
      </div>
    </Modal>
  );
});

export default ViewLoanModal;